import React from 'react'
import { Link } from 'react-router-dom'

export default function AdminPortal() {
    return (
        <div className="bg-slate-900 p-4 border border-slate-700/80 rounded-md">
            <h1 className="text-slate-100 font-bold text-xl">Admin Portal</h1>
            <div className="space-y-2 mt-4 flex flex-col">
                <Link className="link" to="/admin/dashboard">Dashboard</Link>
                <Link className="link" to="/admin/admin-login">AdminLogin</Link>
                <Link className="link" to="/admin/assignment">Assignment</Link>
                <Link className="link" to="/admin/assignment-mark">AssignmentMark</Link>
                <Link className="link" to="/admin/quizzes">Quizzes</Link>
                <Link className="link" to="/admin/videos">Videos</Link>
            </div>
        </div>
    )
}
